export default __webpack_public_path__ + "static/media/07.6ba00043.jpg";